import { SecureCookieAdapter } from '@/infra/adapters/storage/secure-cookie-adapter';
import { IStorage } from '@/infra/interfaces/storage/storage';

function makeSecureStorage(): IStorage {
  return new SecureCookieAdapter();
}

export const secureStorage = makeSecureStorage();
